'use strict';
(function () {
    angular
        .module('invesfleet')
        .directive('suspendWatchers', suspendWatchers);

    suspendWatchers.$inject = [];

    function suspendWatchers() {

        return {
            restrict: 'AE',
            scope : true, //Create a child scope to wrap whatever we want to suspend
            link: function(scope, element, attr) {
                var deregisterClosed;
                var deregisterOpened;

                if (attr.suspendOn) {
                    deregisterClosed = scope.$on('tab-closed-' + attr.suspendOn, function (e) {
                        toggleWatchers(scope, false);
                    });
                    deregisterOpened = scope.$on('tab-opened-' + attr.suspendOn, function (e) {
                        toggleWatchers(scope, true);
                    });
                }

                function toggleWatchers(scope, enable) {
                    var digest, current, next = scope;
                    do {
                        current = next;
                        if (enable) {
                            if (current.hasOwnProperty('$$watchersBackup')) {
                                current.$$watchers = current.$$watchersBackup;
                                delete current.$$watchersBackup;
                                delete current.$watch;
                                digest = !scope.$root.$$phase;
                            }
                        } else {
                            if (!current.hasOwnProperty('$$watchersBackup')) {
                                current.$$watchersBackup = current.$$watchers;
                                current.$$watchers = null;

                                //New watchers added while scope is suspended will now be added to the watchersBackup
                                current.$watch = function () { 
                                    this.$$watchersBackup = this.$$watchersBackup || [];
                                    this.$$watchers = this.$$watchersBackup;
                                    this.constructor.prototype.$watch.apply(this, arguments);
                                    this.$$watchers = null;
                                };
                            }
                        }
                        next = current.$$childHead;
                        while (!next && current !== scope) {
                            if (current.$$nextSibling) {
                                next = current.$$nextSibling;
                            } else {
                                current = current.$parent;
                            }
                        }
                    } while (next);
                    if (digest) {
                        scope.$digest();
                    }
                }
                function disableDigest() {
                    toggleWatchers(scope, false);
                }
                function enableDigest() {
                    toggleWatchers(scope, true);
                }

                scope.$on('$destroy', function() {
                    deregisterClosed();
                    deregisterOpened();
                });
            }
        };
    }
})();